export default {
  本季热播: "本季热播",
  每周日更新: "每周日早 10:00 更新",
  更新至: "更新至",
  话: "话",
  已完结: "已完结",
  精选专题: "精选专题",
  热门推荐: "热门推荐",
  高分神作: "高分神作",
  追番用户评价: "追番用户评价",
  大家都在说: "大家都在说",
  听听追番的朋友们怎么评价: "听听追番的朋友们怎么评价",
  免费动漫随时追番: "免费动漫 随时追番",
  无需下载随时随地畅快追番: "无需下载，随时随地畅快追番",
  海量动漫资源高清流畅播放: "海量动漫资源，高清流畅播放",
  开始你的追番之旅: "开始你的追番之旅",
  每天更新精彩不间断: "每天更新，精彩不间断",
  全网最全动漫资源库: "全网最全动漫资源库",
  立即开始免费观看: "立即开始免费观看",
  手机专为看动漫而生: "手机专为看动漫而生",
  无论何时何地打开浏览器就能看: "无论何时何地，打开浏览器就能看",
  左滑查看更多: "左滑查看更多",
  右滑返回: "右滑返回",
} as Record<string, string>;